import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AutoApproveTimesheetHoursOption, ChapterRadioButtonData } from '@app/+onboarding/chapters/chapter.model';
import { OnboardingChapterModule } from '@app/+onboarding/chapters/components/chapter.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'time-tracking-auto-approve-hours',
  standalone: true,
  imports: [OnboardingChapterModule, TranslateModule],
  templateUrl: './time-tracking-auto-approve-hours.component.html',
})
export class TimeTrackingAutoApproveHoursComponent {
  public autoApproveHours = new FormControl(null, Validators.required);

  public autoApproveHoursOptions: ChapterRadioButtonData[] = [
    {
      value: AutoApproveTimesheetHoursOption.YES,
      label: this.translate.instant('Yes, auto-approve hours'),
      description: this.translate.instant(
        'Clocked hours matching your schedule are added directly as approved timesheets.',
      ),
    },
    {
      value: AutoApproveTimesheetHoursOption.NO,
      label: this.translate.instant('No, do not auto-approve'),
      description: this.translate.instant("Employees' hours are logged but timesheets require your manual approval."),
    },
  ];

  @Input()
  public nextButtonLoading: boolean;

  @Output()
  public next = new EventEmitter<AutoApproveTimesheetHoursOption>();

  public onNext() {
    if (this.autoApproveHours.valid) {
      this.next.emit(this.autoApproveHours.value);
    }
  }

  public constructor(private translate: TranslateService) {}
}
